// src/app/core/store/person/person.state.ts

import { PersonDetail, PersonSearchResult } from '@core/models/person.model';

export interface CacheEntry<T> {
  data: T;
  loadedAt: number;
  ttlMs: number;
}

export interface AsyncSlice<T> {
  data: T | null;
  loading: boolean;
  loaded: boolean;
  error: string | null;
  cache: CacheEntry<T> | null;
}

export function isCacheValid<T>(cache: CacheEntry<T> | null): boolean {
  if (!cache) return false;
  return Date.now() - cache.loadedAt < cache.ttlMs;
}

export function emptySlice<T>(): AsyncSlice<T> {
  return { data: null, loading: false, loaded: false, error: null, cache: null };
}

export const TTL = {
  SEARCH: 2  * 60 * 1000,   // 2 min  — search results
  DETAIL: 5  * 60 * 1000,   // 5 min  — person detail by id / idno
} as const;

export interface PersonState {
  search:  AsyncSlice<PersonSearchResult[]>;
  byId:    Record<number, AsyncSlice<PersonDetail>>;
  byIdNo:  Record<string, AsyncSlice<PersonDetail>>;
}

export const initialPersonState: PersonState = {
  search:  emptySlice<PersonSearchResult[]>(),
  byId:    {},
  byIdNo:  {},
};
